export const isAudioUrl = (url: string): boolean => {
  return /\.(mp3|wav|wave)$/i.test(url);
};
